import React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Skeleton from '@mui/material/Skeleton';

const ProfileCardLoading = () => (
  <Card>
    <CardHeader
      avatar={(
        <Skeleton variant="circular" width={72} height={72} />
      )}
      title={<Skeleton height={40} width={120} />}
      subheader={<Skeleton height={30} width={90} />}
    />
  </Card>
);

ProfileCardLoading.propTypes = { };

export default ProfileCardLoading;
